import { isArrayOfStrings } from './isArrayOfStrings';

export function parseQueryParam(param: string | null): string[] {
    if (param === null) {
        return [];
    }
    try {
        const parsed = JSON.parse(param);
        return isArrayOfStrings(parsed) ? parsed : [param];
    } catch (e) {
        return [param];
    }
}
